import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionTitle from '@/components/feature/SectionTitle';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import NotFound from '../NotFound';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return <NotFound />;
  }

  const categoryArticles = articles.filter((a) => a.categoryId === category.id);
  const relatedCategories = categories.filter((c) => c.id !== category.id).slice(0, 3);

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 51黑料网`,
    description: category.description,
    url: `http://lalaxjk.cn/category/${category.slug}`,
    isPartOf: {
      '@id': 'http://lalaxjk.cn/#website',
    },
    about: {
      '@type': 'Thing',
      name: category.name,
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <Navbar />
      <main>
        {/* Category Hero */}
        <section className="relative w-full pt-20 pb-12 md:pb-16 bg-foreground-950">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '分类', path: '/category/meiri-chigua' },
                { label: category.name },
              ]}
            />
            <div className="mt-6 text-center">
              <h1 className="text-3xl md:text-4xl font-bold text-background-50 mb-3">
                {category.name}
              </h1>
              <p className="text-base text-background-400 max-w-2xl mx-auto">
                {category.description}
              </p>
              <p className="text-sm text-background-500 mt-2">
                共 {categoryArticles.length} 篇爆料 · {category.articleCount} 篇总收录
              </p>
            </div>
          </div>
        </section>

        {/* Articles Grid */}
        <section className="py-10 md:py-14">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 bg-background-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-article-line text-2xl text-foreground-400" />
                </div>
                <p className="text-foreground-500">该分类暂无爆料文章</p>
                <a href="/" className="text-primary-600 text-sm mt-2 inline-block hover:underline">
                  返回首页
                </a>
              </div>
            )}
          </div>
        </section>

        {/* Related Categories */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <SectionTitle title="相关分类" subtitle="RELATED" />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
              {relatedCategories.map((cat) => (
                <a
                  key={cat.id}
                  href={`/category/${cat.slug}`}
                  className="group block bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-300 transition-all hover:shadow-md"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center">
                      <i className={`${cat.icon} text-primary-600`} />
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                        {cat.name}
                      </h3>
                      <p className="text-xs text-foreground-400">{cat.articleCount} 篇爆料</p>
                    </div>
                    <i className="ri-arrow-right-line text-foreground-400 ml-auto group-hover:text-primary-500 transition-all group-hover:translate-x-1" />
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}